const moment = require('./plugins/moment-business-day');
const { DEFAULT_TIMEZONE, DEFAULT_LOCALE } = require('./constants');

if (!moment.initialized) {
  moment.tz.setDefault(DEFAULT_TIMEZONE);
  moment.locale(DEFAULT_LOCALE);

  moment.initialized = true;
}

function momentWrapper() {
  return moment(...arguments).tz(DEFAULT_TIMEZONE);
}

Object.entries(moment).map(([key, value]) => (momentWrapper[key] = value));

module.exports = momentWrapper;
